import {z} from '@hono/zod-openapi';

/** Required for reads whose result is limited by the active dealer brand/profile. */
export const authorizationProfileQuerySchema = z
  .object({authorizationProfileId: z.string().uuid()})
  .strict()
  .openapi('AuthorizationProfileQuery');
export type AuthorizationProfileQuery = z.infer<typeof authorizationProfileQuerySchema>;
